import { useStaticQuery, graphql } from 'gatsby'

export const usePostHeroDefaultQuery = () => {
  const { wp } = useStaticQuery(graphql`
    query PostHeroDefaultQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            post {
              heroImageDefault {
                sourceUrl
                mediaDetails {
                  width
                  height
                }
              }
              heroImageDefaultAltText
            }
          }
        }
      }
    }
  `)
  return wp.acfOptionsCommonItems.commonItems.post
}
